import { Controller } from "@hotwired/stimulus"
import { showHubTeamToast } from "../utils/hub_team_toast"

export default class extends Controller {
  async deactivate(event) {
    event.preventDefault()

    const button = event.currentTarget
    if (button.disabled) return

    const row = button.closest("tr")
    const url = row?.dataset.deactivateUrl
    const memberName = row?.querySelector(".hub-team-member-name-text")?.textContent?.trim() || "this member"

    if (!url) return
    if (!window.confirm(`Deactivate ${memberName}? They will lose access to this team.`)) return

    button.disabled = true

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })

      const data = await response.json()

      if (response.ok && data.success) {
        this.removeRow(row)
      } else {
        const message = data?.errors?.join(", ") || `HTTP ${response.status}`
        showHubTeamToast(`Failed to deactivate member: ${message}`, { variant: "error" })
        button.disabled = false
      }
    } catch (error) {
      console.error("Error deactivating company member:", error)
      showHubTeamToast("An error occurred. Please try again.", { variant: "error" })
      button.disabled = false
    }
  }

  removeRow(row) {
    if (!row) return

    const table = row.closest("[data-controller~='data-table']")
    row.remove()

    this.updateMemberCount(-1)

    if (table) {
      const remainingRows = table.querySelectorAll("tbody tr")
      const emptyState = table.querySelector("[data-data-table-target='noResults']")
      if (emptyState) emptyState.hidden = remainingRows.length > 0
    }

    const editPanel = this.element.querySelector("[data-edit-member-panel-target='panel']")
    if (editPanel && !editPanel.hidden) {
      const editPanelController = this.application.getControllerForElementAndIdentifier(this.element, "edit-member-panel")
      editPanelController?.close()
    }
  }

  updateMemberCount(delta) {
    const countElement = this.element.querySelector(".hub-team-count")
    if (!countElement) return

    const currentCount = parseInt(countElement.textContent, 10) || 0
    countElement.textContent = Math.max(0, currentCount + delta)
  }
}
